import { useEffect, useState } from 'react';
import { Container, Text } from '@pixi/react';
import { BoostedJackpotDateProps, BoostedJackpotTimeType } from '../index.types';
import { BoostedJackpotTime } from '../../../frameModule/constants';
import { boostedJackpotDateHelper } from '../../../../helpers';
import { useStore, useTranslation } from '../../../../../hooks';
import { T } from '../../../../../constants';

let intervalId: any | NodeJS.Timer = null;
export const BoostedJackpotDate: React.FC<BoostedJackpotDateProps> = ({
  x = 0,
  y = 0,
  stylesTimer,
  marginInText,
  isIcon = false,
  marginInContainer,
  hiderTextXPosition,
  durationTextPositions,
}) => {
  const { boostedJackpotStore } = useStore();
  const t = useTranslation();
  const [_, setTimeer] = useState<string>();
  const { days, hours, minutes, seconds } = boostedJackpotDateHelper(boostedJackpotStore.boostedJackpotEndTime);

  useEffect(() => {
    intervalId = setInterval(() => {
      setTimeer(boostedJackpotDateHelper(boostedJackpotStore.boostedJackpotEndTime).days);
      setTimeer(boostedJackpotDateHelper(boostedJackpotStore.boostedJackpotEndTime).hours);
      setTimeer(boostedJackpotDateHelper(boostedJackpotStore.boostedJackpotEndTime).minutes);
      setTimeer(boostedJackpotDateHelper(boostedJackpotStore.boostedJackpotEndTime).seconds);
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const stylesHider = {
    align: 'center',
    fill: '#FFFFFF',
    fontWeight: '700',
    fontSize: isIcon ? 9 : 11,
    fontFamily: 'poppinsMedium',
  };

  const dateTime: BoostedJackpotTimeType[] = BoostedJackpotTime(
    days,
    hours,
    isIcon,
    minutes,
    seconds,
    stylesTimer,
    stylesHider,
    marginInText,
    hiderTextXPosition,
  );

  const newDateTime: BoostedJackpotTimeType[] = isIcon ? dateTime.filter((el) => el.length) : dateTime;

  return (
    <Container x={x} y={y} {...({ name: 'BoostedJackpotPopupDate' } as any)}>
      {!isIcon && (
        <Text
          resolution={2}
          x={durationTextPositions.x}
          y={durationTextPositions.y}
          {...({ name: 'text' } as any)}
          text={t(T.DURATION)}
          anchor={0.5}
          style={{
            fontSize: 10,
            align: 'center',
            fill: '#FFFFFF',
            fontWeight: '700',
            fontFamily: 'poppinsMedium',
          }}
        />
      )}
      {newDateTime.map((times, index) => {
        return (
          <Container key={index} x={index * marginInContainer}>
            {times.map(({ text, textX, textY, stylesTimer, stylesHider }) => {
              return (
                <Text
                  x={textX}
                  y={textY}
                  key={textX}
                  anchor={0.5}
                  text={t(text || '')}
                  resolution={2}
                  style={stylesHider || stylesTimer}
                />
              );
            })}
          </Container>
        );
      })}
    </Container>
  );
};
